import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { SharePageEntity } from './share-page.entity'

export class SharePagesRepository extends BaseRepository<SharePageEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'share-pages', token, cache)
    }

    async publicGetOneByToken(sharePageId: string, token: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.toolsApiUrl + '/share-pages/' + sharePageId + '/public?token=' + token,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
